export const ADMIN = 'administrator';
export const CS = 'customer success';
export const ACCOUNTANT = 'accountant';
export const ASSOCIATE = 'accounting associate';
export const PA = 'partner accountant';
export const SALES = 'sales';
export const CLIENT = 'client';
